import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{staticClass:"py-16 text-center"},[_c('h1',{staticClass:"text-h5 mb-4"},[_vm._v("找不到這個頁面")]),_c('p',[_vm._v("網址可能已變更，請從首頁重新選擇需要的服務。")]),_c(VBtn,{attrs:{"color":"primary","to":{ name: 'Index' }}},[_vm._v("回到首頁")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }